export enum MFAStep {
  SET_PHONE = 'setPhone',
  ENTER_SMS_CODE = 'enterSmsCode',
  MULTI_FACTOR_AUTH_ENABLED = 'multiFactorAuthEnabled',
}

export enum MFAMethod {
  NOMFA = 'NOMFA',
  SMS_MFA = 'SMS_MFA',
}

export const defaultSubTitle = 'Welcome Back!';
